import React, { forwardRef, useEffect, useRef, useState } from "react";
import {
  Drawer,
  Box,
  Checkbox,
  Divider,
  Fade,
  IconButton,
  Menu,
  MenuItem
} from "@material-ui/core";

import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import MTableAction from "./m-table-action";

import FileCopyIcon from "@material-ui/icons/FileCopy";

import CustomToolbar from "./CustomToolbar";

import clsx from "clsx";

import Skeleton from "@material-ui/lab/Skeleton";

import MTablePagination from "./m-table-pagination";
import ConfirmDialog from "../../dialogs/ConfirmDialog";

import makeStyles from "@material-ui/core/styles/makeStyles";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Check from "@material-ui/icons/Check";
import Clear from "@material-ui/icons/Clear";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Search from "@material-ui/icons/Search";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { connect } from "react-redux";
import { setInfoDialog } from "../../../store/actions/common";
import LoadingCircle from "../../common/LoadingCircle";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { remCalc } from "../../../utils/helpers";

const tableIcons = {
  Add: forwardRef((props, ref) => null),
  Check: forwardRef((props, ref) => (
    <Check data-cy="projects-actionOk" {...props} ref={ref} />
  )),
  Clear: forwardRef((props, ref) => (
    <Clear data-cy="projects-actionCancel" {...props} ref={ref} />
  )),
  Delete: forwardRef((props, ref) => (
    <Delete data-cy="projects-actionDelete" {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => (
    <Edit data-cy="projects-actionEdit" {...props} ref={ref} />
  )),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />)
};

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: "1302 !important"
  },

  paper: {
    maxWidth: "100%"
  },

  pagination: {
    alignItems: "center",
    width: "auto",
    flexShrink: 0,
    color: theme.palette.text.secondary,
    display: "flex"
  },

  paginationWrapper: {
    position: "absolute",
    top: 72,
    left: 0,
    right: 0,
    borderBottom: "1px solid #eee",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    height: 47
  },

  checkbox: {
    pointerEvents: "auto",
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(1),
    "& .MuiSvgIcon-root": {
      color: "inherit"
    }
  },
  backdrop: {
    opacity: "40% !important",
    backgroundColor: theme.palette.text.primary
  },
  pageCountText: {
    flex: 1,
    textAlign: "center",
    alignSelf: "center",
    flexBasis: "inherit",
    fontSize: "0.9375rem",
    fontWeight: 400,
    padding: theme.spacing(1.125, 1),
    marginRight: theme.spacing(1),
    color: "#202124"
  },
  navBtn: {
    "& svg": {
      color: "inherit"
    }
  },

  emptyRows: {
    "& tbody": {
      "& tr.MuiTableRow-root": {
        position: "relative"
      },
      "& tr.MuiTableRow-root:not([index])": {
        display: "none !important"
      }
    }
  },

  tableWrapper: {
    minWidth: 600,
    transition: theme.transitions.create(["padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    width: "100%",

    "&.duplicate-allowed": {
      "& td, & th": {
        "&:first-child": {
          width: ({ dropdownActions }) =>
            dropdownActions ? "25px !important" : "150px !important"
        }
      }
    },

    "&.switch-allowed": {
      "& tbody tr": {
        height: "56px !important",
        "& td:last-of-type > p": {
          fontSize: "0.875rem",
          lineHeight: "20px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          "-webkit-box-orient": "vertical",
          "-webkit-line-clamp": 2
        }
      },
      "& td, & th": {
        "&:first-child": {
          width: "170px !important",
          "& > div > button:first-of-type": {
            order: -2,
            padding: theme.spacing(0)
          },
          "& > div > button:first-of-type:hover": {
            backgroundColor: "inherit"
          }
        },
        "&:last-child": {
          whiteSpace: "unset"
        }
      }
    },

    "& .MuiPaper-root > .MuiTable-root tr": {
      height: "0 !important"
    },

    "&  .MuiToolbar-regular": {
      padding: theme.spacing(2),
      height: 72,
      boxSizing: "border-box",

      "& .MuiButton-text": {
        display: "none"
      },

      "& .MuiButton-text.action-disabled": {
        opacity: "38%",
        cursor: "default",
        "&:hover": {
          backgroundColor: "unset"
        }
      },

      "& h6": {
        fontSize: "1.25rem",
        fontWeight: 500
      }
    },

    "& #edit-date[value=Date]": {
      color: "rgba(0,0,0,.42)"
    },

    "& .MuiTable-root": {
      tableLayout: "fixed",

      "& tr": {
        height: "48px !important"
      },

      "& tbody": {
        overflowY: "auto",

        "& tr": {
          "&:MuiIconButton-label": {
            width: 24
          },

          "&.active": {
            backgroundColor: "#ECEEFF"
          },

          "& .actions-menu-icon": {
            opacity: 0
          },

          "&:hover .actions-menu-icon": {
            opacity: 1
          },

          "&.action-disabled": {
            pointerEvents: "none",
            "& td:not(:first-child)": {
              background: "none",
              opacity: "0.35 !important"
            }
          },

          "& td:first-child > div": {
            flexDirection: "row-reverse",
            justifyContent: "flex-end",
            alignItems: "center",
            "& .action-disabled": {
              background: "none !important",
              "& *": {
                background: "none !important",
                color: theme.palette.text.disabled
              },
              cursor: "default",
              color: theme.palette.text.disabled
            },
            "&> :last-child": {
              order: -2
            }
          },
          "&:hover": {
            backgroundColor: "#EEEEEE"
          }
        }
      },

      "& tr:first-of-type th": {
        border: "none",
        paddingRight: "4px !important",
        // position: "relative"

        "&::after": {
          content: '""',
          fontSize: 0,
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: 1,
          backgroundColor: "#eee"
        }
      },

      "& th": {
        fontSize: "0.75rem",
        color: "#808080"
      },

      "& td, & p": {
        fontSize: "0.9375rem",
        color: "#202124 !important"
      },

      "& td": {
        boxSizing: "border-box"
      },

      "& td, & th": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        borderColor: "#eee",
        padding: theme.spacing(0, 1.75, 0, 2) + " !important",

        "&:first-child": {
          width: "115px !important",
          overflow: "visible",
          pointerEvents: "none",
          "& button": {
            pointerEvents: "auto"
          }
        },

        "&:nth-child(2)": {
          padding: theme.spacing(0, 1.75, 0, 2.5) + " !important"
        },

        width: theme.spacing(10)
      },

      "& th:first-child": {
        textAlign: "left !important",
        "& .MuiTableSortLabel-icon": {
          display: "none"
        }
      }
    }
  },
  addBtn: {
    textTransform: "none",
    marginLeft: theme.spacing(1.5),
    boxShadow: "none",
    fontWeight: "normal",
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    "& svg": {
      color: "#fff",
      fontSize: "24px !important"
    },
    position: "absolute",
    zIndex: "10",
    top: "82px",
    left: "90px"
  },
  filterTab: {
    minWidth: 0,
    marginRight: 32,
    padding: 0,
    textTransform: "none"
  }
}));

function CommonMaterialTable({
  isApp,
  onRowClick,
  open,
  confirmDialogState,
  drawerOpen,
  title,
  plural,
  singular,
  upload,
  plan,
  downloadable,
  handleMultipleDownload,
  customWrapperClass,
  setInfoDialog,
  handleSwitch,
  handleDuplicate,
  handleAdd,
  handleEdit,
  setConfirmDialogState,
  loadingCircle,
  setLoadingCircle,
  handleClose,
  getDataPerPage,
  selected,
  handleOpen,
  currentAction,
  activeItem,
  pagination,
  loading,
  duplicateAllowed,
  switchAllowed,
  handleMultipleDelete,
  handleDelete,
  data,
  columns,
  setSelected,
  inline = false,
  tabs = undefined,
  currentTabId,
  onTabChange,
  dropdownActions = false,
  openDropdownActionsMenu,
  addButtonDisabled = false,
  rowActionsDisabled = false,
  onRowClickDisabled = false,
  addId
}) {
  const classes = useStyles({ dropdownActions });
  const isSelected = id =>
    selected.map(item => (isApp ? item.id : item)).includes(id);
  const { totalQuantity, currentPage, setCurrentPage, isNextButtonDisabled } =
    pagination || {};

  useEffect(() => {
    if ((open || inline) && pagination?.enabled) {
      getDataPerPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inline, open, currentPage]);

  const numSelected = selected.length;
  const count = data.length;

  const onSelectAllClick = () => {
    if (allSelected) {
      setSelected([]);
    } else {
      setSelected(
        tRef.current
          ? tRef.current.state.data.map(data => (isApp ? data : data.id))
          : data.map(data => (isApp ? data : data.id))
      );
    }
  };

  const tRef = useRef();

  const allSelected = tRef.current && count > 0 && numSelected >= data.length;

  const tableJSX = (
    <>
      {/* Loading */}
      <Fade in={loadingCircle} mountOnEnter unmountOnExit>
        <LoadingCircle style={{ paddingLeft: drawerOpen ? 280 : 56 }} />
      </Fade>
      <Box
        className={clsx(classes.tableWrapper, customWrapperClass || "", {
          "duplicate-allowed": duplicateAllowed,
          "switch-allowed": switchAllowed
        })}
        id={`tableWrapper-${plural}`}
        style={{
          paddingLeft: inline ? 0 : drawerOpen ? 280 : 56,
          height: "100%",
          maxWidth: inline ? "100%" : 904
        }}
      >
        <MaterialTable
          tableRef={tRef}
          components={{
            Body: props => {
              if (tRef.current) {
                const { searchText, renderData, originalData } =
                  tRef.current.state;
                if (!renderData.length && !loading) {
                  return (
                    <tbody className="MuiTableBody-root">
                      <tr
                        className="MuiTableRow-root"
                        style={{ height: "735px" }}
                      >
                        <td
                          className="MuiTableCell-root MuiTableCell-body"
                          colSpan={tRef.current?.props.columns.length + 1}
                          style={{
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            textAlign: "center"
                          }}
                        >
                          {!searchText && !originalData.length
                            ? `No ${plural} to display`
                            : `No ${plural} matched your search`}
                        </td>
                      </tr>
                    </tbody>
                  );
                }
              }

              return <MTableBody {...props} />;
            },
            Toolbar: props => {
              return (
                <CustomToolbar
                  {...props}
                  isApp={isApp}
                  handleClose={() => handleClose()}
                  activeProjectId={activeItem}
                  selected={selected}
                  singular={singular}
                  plural={plural}
                  pagination={pagination}
                  plan={plan}
                  handleMultipleDownload={
                    downloadable && handleMultipleDownload
                  }
                  getDataPerPage={getDataPerPage}
                  loading={loading}
                  setInfoDialog={setInfoDialog}
                  upload={upload}
                  handleOpen={handleOpen}
                  currentAction={currentAction}
                  totalQuantity={totalQuantity}
                  handleMultipleDelete={handleMultipleDelete}
                  setConfirmDialogState={setConfirmDialogState}
                  setLoadingCircle={setLoadingCircle}
                  setSelected={setSelected}
                  handleAdd={handleAdd}
                  addId={addId}
                  inline={inline}
                  addButtonDisabled={addButtonDisabled}
                />
              );
            },
            Row: props => {
              return (
                <MTableBodyRow
                  {...props}
                  key={props.data.id}
                  id={`row-${props.data.id}`}
                  className={clsx({
                    active: props.data.id === activeItem,
                    "action-disabled":
                      selected.length &&
                      !selected
                        .map(item => (isApp ? item.id : item))
                        .includes(props.data.id)
                  })}
                />
              );
            },
            Action: props => {
              return (
                <MTableAction
                  {...props}
                  selectedLength={selected.length}
                  selected={isSelected(props.data.id)}
                  classes={{ checkbox: classes.checkbox }}
                  plural={plural}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  disabled={rowActionsDisabled}
                />
              );
            },
            Pagination: props => {
              return (
                <>
                  <Box
                    className={classes.paginationWrapper}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    {tabs && (
                      <Tabs
                        indicatorColor={"primary"}
                        value={currentTabId}
                        onChange={(event, tabId) => onTabChange(tabId)}
                      >
                        {tabs.map(tab => (
                          <Tab
                            label={tab.label}
                            className={classes.filterTab}
                            value={tab.id}
                            disabled={loading}
                          />
                        ))}
                      </Tabs>
                    )}
                    <MTablePagination
                      {...props}
                      setSelected={setSelected}
                      classes={{
                        pagination: classes.pagination,
                        root: props.classes.root,
                        pageCountText: classes.pageCountText,
                        iconButton: classes.navBtn
                      }}
                      // editing={editing}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      totalQuantity={totalQuantity}
                      loadingProjects={loading}
                      showFirstLastPageButtons={false}
                      {...(isNextButtonDisabled && {
                        isNextButtonDisabled
                      })}
                    />
                  </Box>
                </>
              );
            }
          }}
          onRowClick={!onRowClickDisabled ? onRowClick : undefined}
          className={classes.paper}
          stickyHeader
          icons={tableIcons}
          style={{
            overflowY: "hidden",
            height: "100%",
            flexDirection: "column",
            display: "flex",
            ...(inline
              ? {
                  border: 0,
                  boxShadow: "none"
                }
              : {})
          }}
          options={{
            paging: pagination,
            search: true,
            pageSize: 15,
            pageSizeOptions: [15, 16],
            showFirstLastPageButtons: false,
            addRowPosition: "first",
            draggable: false,
            searchFieldStyle: {
              display: "none"
            },
            headerStyle: {
              position: "sticky",
              top: 0,
              backgroundColor: "#F7F7F7"
            },
            thirdSortClick: false,
            overflowY: "visible"
          }}
          columns={[
            ...columns,
            ...(dropdownActions
              ? [
                  {
                    title: "",
                    field: "",
                    editable: "never",
                    initialEditValue: "Open",
                    searchable: false,
                    sorting: false,
                    cellStyle: {
                      width: remCalc(40)
                    },
                    headerStyle: {
                      width: remCalc(40)
                    },
                    render: rowData => {
                      return (
                        <IconButton
                          onClick={event => {
                            event.stopPropagation();
                            console.log(event.currentTarget);
                            openDropdownActionsMenu(
                              rowData,
                              event.currentTarget
                            );
                          }}
                          disableFocusRipple
                          className={"actions-menu-icon"}
                        >
                          <MoreHorizIcon />
                        </IconButton>
                      );
                    }
                  }
                ]
              : [])
          ]}
          actions={[
            !dropdownActions &&
              duplicateAllowed && {
                isFreeAction: false,
                tooltip: "Duplicate",
                icon: () => <FileCopyIcon data-cy="project-actionDuplicate" />,
                onClick: (e, rowData) => {
                  handleDuplicate(rowData);
                }
              },
            !dropdownActions &&
              switchAllowed && {
                isFreeAction: false,
                tooltip: "",
                icon: "Switch",
                onClick: (e, rowData) => {
                  handleSwitch(rowData);
                }
              },
            {
              isFreeAction: false,
              icon: "Select",
              onClick: (e, rowData) => {
                if (isSelected(rowData.id))
                  setSelected(
                    selected.filter(
                      item => (isApp ? item.id : item) !== rowData.id
                    )
                  );
                else setSelected([...selected, isApp ? rowData : rowData.id]);
              }
            }
          ]}
          data={data}
          localization={{
            header: {
              actions: (
                <Box display="flex" alignItems="center">
                  <Checkbox
                    indeterminate={numSelected > 0 && numSelected < data.length}
                    checked={count > 0 && numSelected === data.length}
                    onChange={onSelectAllClick}
                    color="primary"
                    data-cy={`selectAll-${plural}`}
                    className={clsx(classes.checkbox)}
                    style={{ padding: 8 }}
                    disabled={rowActionsDisabled}
                  />
                  <Divider
                    orientation="vertical"
                    style={{ height: 20, marginRight: "4px" }}
                  />
                </Box>
              )
            },
            body: {
              deleteTooltip: "Delete",
              editTooltip: "Edit",
              addTooltip: "",
              emptyDataSourceMessage: loading && (
                <>
                  <Skeleton style={{ marginTop: "8px" }} />
                  <Skeleton style={{ marginBottom: "8px" }} />
                </>
              )
            }
          }}
          title={title}
          editable={{
            isEditable: rowData => {
              return (
                rowData.status !== "Completed" && rowData.status !== "Expired"
              );
            },
            onRowUpdate:
              !dropdownActions && handleDelete
                ? (newItem, oldItem) => new Promise((resolve, reject) => {})
                : null,
            onRowAdd: newItem => new Promise((resolve, reject) => {}),
            onRowDelete:
              !dropdownActions && handleDelete
                ? item => new Promise((resolve, reject) => {})
                : null
          }}
        />
      </Box>
    </>
  );

  return (
    <>
      {!inline && (
        <Drawer
          disableEscapeKeyDown
          open={open}
          id={`${plural}Dialog`}
          onClose={handleClose}
          className={classes.root}
          classes={{
            paper: classes.paper
          }}
          anchor="left"
          ModalProps={{
            BackdropProps: { className: classes.backdrop },
            disableEnforceFocus: true
          }}
        >
          {tableJSX}
        </Drawer>
      )}
      {inline && tableJSX}

      <ConfirmDialog
        isProject={!confirmDialogState.confirmText}
        open={confirmDialogState.open}
        handleClose={() =>
          setConfirmDialogState({ ...confirmDialogState, open: false })
        }
        action={confirmDialogState.action}
        title={confirmDialogState.title}
        body={confirmDialogState.body}
        confirmText={confirmDialogState.confirmText}
      />
    </>
  );
}

const mapStateToProps = state => ({
  drawerOpen: state.account.accountDrawerOpen,
  plan:
    (state.auth.userData.organisationSite &&
      state.auth.userData.organisationSite.organisation.plan) ||
    {}
});

export default connect(mapStateToProps, {
  setInfoDialog
})(CommonMaterialTable);
